/* global window */
'use strict';

module.exports = function () {
    if (window.document.location.hash && window.document.location.hash.indexOf('phxDebug') !== -1) {
        return function () {
            var args = Array.prototype.slice.apply(arguments);
            let now =
                window.performance && window.performance.now ? window.performance.now() | 0 : Date.now();
            args.unshift('%c[phxDebug] ' + now + '%c', 'font-weight:bold', 'font-weight:normal');
            // eslint-disable-next-line no-console
            console.log.apply(console, args);
        };
    } else {
        return () => {};
    }
};
